import SystemRoleTable from "./components/SystemRoleTable";

const SystemRoleComponent = () =>{

    return(
        <SystemRoleTable />
    )
}
export default SystemRoleComponent;